import { useBackInStockModalContext } from 'back-in-stock/src/hooks/useBackInStockModalContext/useBackInStockModalContext'
import { useCallback } from 'react'

export function useBackInStock() {
	const { backInStockModalProps, setBackInStockModalProps } =
		useBackInStockModalContext()

	const handleBackInStock = useCallback(
		(props: {
			product: string
			size: string
			name: string
			color: string
		}) => {
			setBackInStockModalProps({
				productId: props.product,
				productSizeId: props.size,
				productName: props.name,
				productColorId: props.color,
				feedbackDelay: 0,
			})
		},
		[setBackInStockModalProps]
	)

	return {
		handleBackInStock,
		backInStockModalProps,
	}
}
